var map = {
	"./game01-1.png": 97170,
	"./game02-1.png": 12257,
	"./game03-1.png": 5060,
	"./game04-1.png": 47435,
	"./game05-1.png": 84534,
	"./game06-1.png": 15141,
	"./game07-1.png": 48312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23160;